import $ from 'jquery'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import ClipBoard from '@/components/clipboard';
import { ref } from 'vue'

export default {
    name: 'manage-consultation-commentaire',
    components: { VueEditor, ClipBoard },
    props: {
        consultation: Object,
        user_id: Number,
        evolution_id: Number,
        comment_selected: Object,
        slug: String
    },
    data() {
        return {
            info_consultation: {
                id: 0,
                consultation_id: 0,
                user_id: 0,
                data_type: '',
                titre: '',
                content: ''
            },
            save_loading: false,

            del_loading: false,
            is_confirm: false,
            is_error: false,
            permission_is_denied: false,
            customToolbar: vueEditorToolbar,

            is_recording: ref(false),

            recognition: null,
            transcript: '',
            is_listening: false,
            recognition_err_msg: ''
        }
    },

    watch: {
        comment_selected() {
            if (this.is_listening) {
                this.stopRecording()
            }

            let r_content = this.comment_selected.content
            r_content = r_content.replace("<div class=\"w-100 algn-right\">", "[DROITE]")
            r_content = r_content.replace("</div>", "[/DROITE]")

            this.info_consultation = {
                id: (this.comment_selected.id)?this.comment_selected.id:0,
                consultation_id: (this.comment_selected.consultation_id)?this.comment_selected.consultation_id:'',
                user_id: 0,
                data_type: this.slug,
                titre: (this.comment_selected.title)?this.comment_selected.title:'',
                content: (this.comment_selected.content)?r_content:''
            }
        }
    },

    computed: {
        
    },
    
    mounted() {

    },

    methods: {
        async submit() {
            const refName = 'c_comment'+this.evolution_id+this.slug;
            const fromRef = 'comment_form'+this.evolution_id+this.slug;

            const isValid = await this.$refs[fromRef].validate();

            if (!isValid) {
                return;
            }

            this.info_consultation.consultation_id = this.consultation.id
            this.info_consultation.evolution_id = this.evolution_id
            this.info_consultation.user_id = this.user_id
            this.info_consultation.data_type = this.slug
            this.save_loading = true

            console.log(this.info_consultation);
            this.$store.dispatch('saveConsultationInfoComplementaire', this.info_consultation).then((response) => {
                if (response > 0) {
                    this.successToast("Enrrgistrement effectué avec succès")
                    this.$emit("emitCommentaire")

                    this.$refs[fromRef].reset()
                    this.$refs[refName].click()
                    
                    this.info_consultation = {
                        id: 0,
                        consultation_id: 0,
                        user_id: 0,
                        data_type: '',
                        titre: '',
                        content: ''
                    }
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                
                if (this.is_listening) {
                    this.stopRecording()
                }
                this.save_loading = false
            }).catch(() => {
                this.errorToast("Une errreur s'est produite. Vérifier l'état de le connexion internet puis réssayer.")
                this.save_loading = false
            })
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            let data = {
                data_type: this.slug,
                consultation_id: this.consultation.id,
                info_compl_id: this.comment_selected.id,     // ID commentaire 
                user_id: this.user_id
            }

            this.$store.dispatch('deleteConsultationInfoComplementaire', data).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")
                    this.$emit('emitCommentaire')

                    this.is_confirm = false
                    this.$refs.del_comment.click();
                } else {
                    if (response === -1) {
                        this.is_error = true
                    } else if (response === -2) {
                        this.permission_is_denied = true
                    }
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },

        removeParagraph(text) {
            return text?.replace(/<p>/g, '').replace(/<\/p>/g, '');
        },

        recordSpeech() {
            this.recognition_err_msg = ''
            const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!SpeechRecognition) {
                this.recognition_err_msg = "La conversion Audio-Text n'est pas supportée par votre navigateur ! "+
                    "Merci d'utiliser un navigateur moderne comme Google Chrome ou Microsoft Edge."
                return
            }
            this.is_listening = true

            this.recognition = new SpeechRecognition()
            this.recognition.continuous = true
            this.recognition.interimResults = true
            this.recognition.lang = 'fr-FR'

            this.recognition.onend = () => {
                this.is_listening = false
            }

            this.recognition.onresult = (evt) => {
                for (let i = evt.resultIndex; i < evt.results.length; ++i) {
                    this.$refs.txtzone_editor.quill.blur()

                    this.transcript = evt.results[i][0].transcript

                    this.info_consultation.content = this.removeParagraph(this.info_consultation.content)
                    if (evt.results[i].isFinal) {
                        this.info_consultation.content += this.transcript
                    } 
                }
            }

            this.recognition.onerror = (evt) => {
                this.recognition_err_msg = "Une erreur est survenue lors de la conversion Audio-Text. "+
                    "Merci de vérifier votre connexion internet !"
                console.log("Speech recognition error: ",evt);
                this.recognition.stop();
                this.is_listening = false;
            }

            this.recognition.start()
        },

        stopRecording() {
            this.recognition_err_msg = ''
            this.recognition.stop();
            this.is_listening = false;
        
            // Optional: Clear the transcript if you want to start fresh next time
            this.transcript = ""; 
        }
    }
}


